import React, { useState } from "react";
import Fade from "@material-ui/core/Fade";
import { Link, Outlet, useNavigate } from "react-router-dom";
import Footer from "../Layout/Footer";
import Loader from "../Component/Loader";
import { withRouter } from "../Utils/withRouter";

function Home(props) {
  let activeUrl = window.location.pathname.replace("/", "");
  const [checked, setChecked] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();
  const togglePopup = () => setIsPopupOpen(!isPopupOpen);

  const ResponsiveNxaDropdown = () => {
    window.$("#navbarSupportedContentmob").removeClass("show");
  };
  const productListArr = [
    {
      id: 1,
      name: "Call",
      link: "/calls",
      img: "..\\assets\\images\\product_dropdown\\call.svg",
    },
    {
      id: 2,
      name: "Meet",
      link: "/meetings",
      img: "..\\assets\\images\\product_dropdown\\meet.svg",
    },
    {
      id: 3,
      name: "Message",
      link: "/message",
      img: "..\\assets\\images\\product_dropdown\\Message.svg",
    },
    {
      id: 4,
      name: "Internet",
      link: "#",
      img: "..\\assets\\images\\product_dropdown\\Internet.svg",
    },
    {
      id: 5,
      name: "Mobile App",
      link: "#",
      img: "..\\assets\\images\\product_dropdown\\mobile.svg",
    },
    {
      id: 6,
      name: "Devices",
      link: "#",
      img: "..\\assets\\images\\product_dropdown\\devices.svg",
    },
  ];
  const localBusinessArr = [
    {
      id: 1,
      name: "South Africa",
      link: "#",
      img: "../assets/images/product_dropdown/sa.svg",
    },
    {
      id: 2,
      name: "Kenya",
      link: "#",
      img: "../assets/images/product_dropdown/kenya.svg",
    },
    {
      id: 3,
      name: "Nigeria",
      link: "#",
      img: "../assets/images/product_dropdown/nigeria.svg",
    },
    {
      id: 4,
      name: "Uganda",
      link: "#",
      img: "../assets/images/product_dropdown/uganda.svg",
    },
    {
      id: 5,
      name: "Zimbabwe",
      link: "#",
      img: "../assets/images/product_dropdown/zimbabwe.svg",
    },
  ];

  return (
    <>
      <Fade in={checked} timeout={500}>
        <React.Fragment>
          <div id="main-homepage" className="homepage  h-100 overflow-auto">
            <div className=" text-center bg--orange radius--bottom-right-15 pt--8 pb--8">
              <div className="  d-flex align-items-center justify-content-center gap--10">
                <div className="text--white">
                  Recognized for Innovation in Business Communication – See Why
                  We Won
                </div>
                <div
                  className="btn radius--50 pt--4 pb--4 pr--10 pl--10 bg--white text--gray-64 dm-sans fw--700 position-relative"
                  onClick={togglePopup}
                >
                  Read about it
                  {isPopupOpen && (
                    <div
                      className="popup-overlay"
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                      }}
                    >
                      <div
                        className="popup-content"
                        style={{
                          width: "95%",
                          maxWidth: "600px",
                          height: "90%",
                          backgroundColor: "#fff",
                          borderRadius: "15px",
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        {/* Close Button */}
                        <button
                          className="close-btn"
                          style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "#FF7A00",
                            color: "#FFFFFF",
                            border: "none",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={togglePopup}
                        >
                          &times;
                        </button>

                        {/* Content Area */}
                        <div
                          style={{
                            padding: "10px",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <iframe
                            src="https://www.nedbank.co.za/content/dam/nedbank/site-assets/Business/SmallBusinessServices/PDFDocuments/Nedbank%20Business%20Ignite%20Press%20Release%204%20November%202020.pdf#toolbar=0&view=FitH&zoom=200"
                            style={{
                              width: "100%", // Ensure it takes up the full width of the container
                              height: "100%", // Adjust to fit the parent container height
                              border: "none", // Remove border for cleaner UI
                              overflow: "hidden", // Prevent horizontal scrolling
                            }}
                            title="Nedbank Business Ignite"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <header
              className={`header ${
                activeUrl === "" ? "home-page-navbar" : "Pricing-header-bg"
              }`}
            >
              <div className="container">
                <nav className="first-nav navbar navbar-expand-lg d-none d-lg-flex  ">
                  <Link
                    to="#"
                    style={{ zIndex: "9999" }}
                    className="navbar-brand"
                  >
                    <img
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate("/");
                      }}
                      src="./../assets/images/nxatel.webp"
                      alt="logo"
                      className="w--147"
                    />
                  </Link>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav ml-auto navigation gap--20">
                      <li className="nav-item">
                        <a
                          className="nav-link "
                          style={{
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#5454D4",
                          }}
                          href="#"
                        >
                          Join Meeting
                        </a>
                      </li>

                      <li className="nav-item">
                        <a
                          className="nav-link "
                          style={{
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#5454D4",
                          }}
                          href="https://support.nxa.tel/portal/"
                        >
                          Support
                        </a>
                      </li>
                      <li className="nav-item ">
                        <Link
                          to="/login"
                          className="nav-link sf--d-bold text--red-f037 hover-text--red-f037 font--16 text-capitalize border--2 border--red-f037 pt--8 pb--8 pr--30 pl--30 radius--5 bg--transparent"
                        >
                          Login
                        </Link>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link sf--d-bold text--white font--16 text-capitalize border--2 border--red-f037 pt--8 pb--8 pr--10 pl--10 radius--5 bg--red-f037 "
                          href="/signup"
                        >
                          Try for Free
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
                <nav className="second-nav navbar navbar-expand-lg navbar-bottom d-none d-lg-flex">
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav ml-auto navigation-banner gap--48">
                      <li className="nav-item dropdown w--110 text-center">
                        <a
                          className={`nav-link dropdown-toggle  after-none text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer ${
                            [
                              "calls",
                              "meetings",
                              "message",
                              "nxa-docs",
                              "business-cloud",
                              "business-internet",
                            ].includes(activeUrl)
                              ? "active"
                              : ""
                          }`}
                          href={void 0}
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Product
                          <i className="fas fa-chevron-down ml-2 font--13"></i>
                        </a>
                        <div
                          className="dropdown-menu   p--5 border--none "
                          aria-labelledby="navbarDropdown"
                          // style={{
                          //   position: "absolute",
                          //   left: "300px",
                          // }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            {" "}
                            <div
                              style={{
                                marginTop: "32px",
                                marginLeft: "45px",
                                marginBottom: "22px",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  marginBottom: "30px",
                                }}
                              >
                                PRODUCTS
                              </div>
                              <div>
                                {productListArr.map((product) => (
                                  <div
                                    key={product.id}
                                    style={{
                                      display: "flex",
                                      justifyContent: "start",
                                      alignItems: "center",
                                      fontSize: "16px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <div>
                                      <img
                                        src={product.img}
                                        height={18}
                                        width={18}
                                        alt={product.name}
                                      />
                                    </div>
                                    <div>
                                      <Link
                                        className={`dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129 ${
                                          activeUrl ===
                                          product.link.replace("/", "")
                                            ? "active"
                                            : ""
                                        }`}
                                        to={product.link}
                                      >
                                        {product.name}
                                      </Link>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div
                                style={{ display: "flex", marginTop: "14px" }}
                              >
                                <div>
                                  <img src="..\assets\images\product_dropdown\googleplay.svg" />
                                </div>
                                <div>
                                  <img src="..\assets\images\product_dropdown\appstore.svg" />
                                </div>
                              </div>
                            </div>
                            {/* Countries Section  */}
                            <div
                              style={{
                                marginTop: "32px",
                                marginLeft: "45px",
                                marginBottom: "22px",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  marginBottom: "30px",
                                  width: "200px",
                                }}
                              >
                                HAVE LOCAL BUSINESS PRESENCE IN AFRICA
                              </div>
                              <div>
                                {localBusinessArr.map((country) => (
                                  <div
                                    key={country.id}
                                    style={{
                                      display: "flex",
                                      justifyContent: "start",
                                      alignItems: "center",
                                      fontSize: "16px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <div>
                                      <img
                                        src={country.img}
                                        height={18}
                                        width={18}
                                        alt={country.name}
                                      />
                                    </div>
                                    <div>
                                      <Link
                                        className={`dropdown-item sf--t-medium mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129 ${
                                          activeUrl ===
                                          country.link.replace("/", "")
                                            ? "active"
                                            : ""
                                        }`}
                                        to={country.link}
                                      >
                                        {country.name}
                                      </Link>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div
                              style={{
                                backgroundColor: "#F3F5F9",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  marginBottom: "30px",
                                }}
                              >
                                <img
                                  src="..\assets\images\product_dropdown\person.png"
                                  height={183}
                                  width={280}
                                />
                              </div>
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    marginTop: "24px",
                                    marginLeft: "46px",
                                  }}
                                >
                                  <div>
                                    <div
                                      style={{
                                        width: " 72px",
                                        height: "19px",
                                        borderRadius: "2px",
                                        background: "#F8CC45",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      Featured
                                    </div>
                                    <div
                                      style={{
                                        width: "146px",
                                        height: "37px",
                                        color: "#F17C2B",
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        marginTop: "8px",
                                      }}
                                    >
                                      Remote Contact Centre
                                    </div>
                                    <div
                                      style={{
                                        marginTop: "76px",
                                      }}
                                    >
                                      <a href="#">
                                        <img
                                          src="..\assets\images\product_dropdown\arrow.svg"
                                          height={20}
                                          width={20}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li class="nav-item dropdown w--110 text-center d-flex align-items-center show">
                        <a
                          class="nav-link text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer "
                          href=""
                        >
                          Solution
                        </a>
                        <a
                          class="dropdown-toggle after-none text--purple-3f4e"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="fas fa-chevron-down ml-2 font--13"></i>
                        </a>
                        <div
                          class="dropdown-menu p--5 border--none  "
                          aria-labelledby="navbarDropdown"
                        >
                          <a
                            href="/start-smart"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                            to="/calls"
                          >
                            Start Smart
                          </a>
                          {/* <a
                            href="https://careers.nxa.tel/jobs/Careers"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                            to="/meetings"
                          >
                            Careers
                          </a> */}
                        </div>
                      </li>

                      <li className="nav-item w--110 text-center">
                        <Link
                          className={`nav-link text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer ${
                            activeUrl === "/pricing" ? "active" : ""
                          }`}
                          to="/pricing"
                        >
                          Pricing
                        </Link>
                      </li>
                      <li class="nav-item dropdown w--110 text-center d-flex align-items-center show">
                        <a
                          class="nav-link text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer "
                          href=" "
                        >
                          Resources
                        </a>
                        <a
                          class="dropdown-toggle after-none text--purple-3f4e"
                          id="navbarDropdown1"
                          role="button"
                          data-toggle="dropdown"
                        >
                          <i class="fas fa-chevron-down ml-2 font--13"></i>
                        </a>
                        <div
                          class="dropdown-menu p--5 border--none  "
                          aria-labelledby="navbarDropdown1"
                        >
                          <a
                            href="/blog"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                          >
                            Blog
                          </a>
                          <a
                            href="https://careers.nxa.tel/jobs/Careers"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                          >
                            Careers
                          </a>
                        </div>
                      </li>
                      <li className="nav-item w--110 text-center">
                        <Link
                          className={`nav-link text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer ${
                            activeUrl === "why-nxatel" ? "active" : ""
                          }`}
                          to="/about-us"
                        >
                          About Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>

                {/* for mobile and ipad */}
                <nav className="navbar navbar-expand-lg navigation d-flex d-lg-none">
                  <Link className="navbar-brand" to="/">
                    {/* <img
                        src="./../assets/images/homepagelogohiring.svg"
                        alt="logo"
                      /> */}
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src="./../assets/images/homepagelogo.png"
                        alt="logo"
                        className="w--110"
                      />
                      {/* <a href="">
                        {" "}
                        <span className="we-hiring">We Hiring</span>
                      </a> */}
                    </div>
                  </Link>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContentmob"
                    aria-controls="navbarSupportedContentmob"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContentmob"
                  >
                    <ul className="navbar-nav ml-auto  bg--white radius--5 p--10 ">
                      <li className="nav-item dropdown">
                        <a
                          className={`nav-link dropdown-toggle  d-flex align-items-center justify-content-between  ${
                            [
                              "calls",
                              "meetings",
                              "message",
                              "nxa-docs",
                              "business-cloud",
                              "business-internet",
                            ].includes(activeUrl)
                              ? "active"
                              : ""
                          }`}
                          href={void 0}
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Product
                        </a>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                        >
                          <div>
                            {productListArr.map((product) => (
                              <div
                                key={product.id}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                <div>
                                  <img
                                    src={product.img}
                                    height={18}
                                    width={18}
                                    alt={product.name}
                                  />
                                </div>
                                <div>
                                  <Link
                                    className={`dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129 ${
                                      activeUrl ===
                                      product.link.replace("/", "")
                                        ? "active"
                                        : ""
                                    }`}
                                    to={product.link}
                                  >
                                    {product.name}
                                  </Link>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </li>
                      <li className="nav-item dropdown">
                        <a
                          className={`nav-link dropdown-toggle  d-flex align-items-center justify-content-between  ${
                            [
                              "calls",
                              "meetings",
                              "message",
                              "nxa-docs",
                              "business-cloud",
                              "business-internet",
                            ].includes(activeUrl)
                              ? "active"
                              : ""
                          }`}
                          href={void 0}
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Local Business Presence
                        </a>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                        >
                          <div>
                            {localBusinessArr.map((country) => (
                              <div
                                key={country.id}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  marginLeft: "15px",
                                }}
                              >
                                <div>
                                  <img
                                    src={country.img}
                                    height={18}
                                    width={18}
                                    alt={country.name}
                                  />
                                </div>
                                <div>
                                  <Link
                                    className={`dropdown-item sf--t-medium mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129 ${
                                      activeUrl ===
                                      country.link.replace("/", "")
                                        ? "active"
                                        : ""
                                    }`}
                                    to={country.link}
                                  >
                                    {country.name}
                                  </Link>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </li>
                      <li class="nav-item dropdown w--110 text-center d-flex align-items-center show">
                        <a
                          class="nav-link text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer "
                          href="/"
                        >
                          Solution
                        </a>
                        <a
                          class="dropdown-toggle after-none text--purple-3f4e"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="fas fa-chevron-down ml-2 font--13"></i>
                        </a>
                        <div
                          class="dropdown-menu p--5 border--none  show"
                          aria-labelledby="navbarDropdown"
                        >
                          <a
                            href="/start-smart"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                            to="/calls"
                          >
                            Start Smart
                          </a>
                          {/* <a
                            href="https://careers.nxa.tel/jobs/Careers"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                            to="/meetings"
                          >
                            Careers
                          </a> */}
                        </div>
                      </li>
                      <li
                        className={`nav-item ${
                          ["demo", "pricing"].includes(activeUrl)
                            ? "active"
                            : ""
                        }`}
                      >
                        <Link
                          className={`nav-link`}
                          to="/pricing"
                          onClick={() => ResponsiveNxaDropdown()}
                        >
                          Pricing
                        </Link>
                      </li>

                      <li
                        className={`nav-item ${
                          activeUrl === "why-nxatel" ? "active" : ""
                        }`}
                      >
                        <Link
                          className={`nav-link`}
                          to="/about-us"
                          onClick={() => ResponsiveNxaDropdown()}
                        >
                          About Us
                        </Link>
                      </li>
                      <li class="nav-item dropdown w--110 text-center d-flex align-items-center ">
                        <a
                          class="nav-link text--purple-3f4e font--16 text-capitalize sf--d-bold border--2 border--transparent border--orange-hover c--pointer "
                          href=""
                        >
                          Resources
                        </a>
                        <a
                          class="dropdown-toggle after-none text--purple-3f4e"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="true"
                        >
                          <i class="fas fa-chevron-down ml-2 font--13"></i>
                        </a>
                        <div
                          class="dropdown-menu p--5 border--none "
                          aria-labelledby="navbarDropdown"
                        >
                          <a
                            href="/blog"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                          >
                            Blog
                          </a>
                          <a
                            href="https://careers.nxa.tel/jobs/Careers"
                            target="_self"
                            class="dropdown-item sf--t-medium  mr--30 font--16 text-capitalize pt--9 pb--9 pr--12 pl--12 border--bottom-1 border--gray-f0fb text--black-2129   "
                          >
                            Careers
                          </a>
                        </div>
                      </li>

                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="https://support.nxa.tel/portal/"
                        >
                          Support
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
                {/* end here */}
              </div>
            </header>
            <Outlet />
            <Footer />
          </div>
        </React.Fragment>
      </Fade>
      <Loader />
    </>
  );
}

export default withRouter(Home);
